{
  "name": "production",
  "hostname": "safarilaw.com",
  "default": null,
  "development": false,
  "production": true,
  "applicationName": "Safari SOP",
  "sourceVersion": "5d92255d71cc5c14701c9dae1e523a0e8d84166a",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.safarilaw.com/_api/comanage/",
    "apiRootLpms": "https://@.safarilaw.com/_api/lpms/",
    "apiRootSquirrel": "https://@.safarilaw.com/_api/squirrel/",
    "apiRootRms": "https://@.serveport.com/_api/rms/",
    "serveportPortalRoot": "https://app.serveport.com/serve/",
    "serveportAgencyPortalUrl": "https://agency.serveport.com/"
  },
  "auth0": {
    "authorityRoot": "auth.safarilaw.com",
    "clientId": "4rYuYDZzWDvmo8KoJXh637eKoBt6PBDE",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 60,
    "inactivityWarning": 5
  },
  "statusApp": {
    "apiRootUrl": "https://@.safarilaw.com/_api/maintenance/",
    "code": "IldIjcjp1bhvMua1TOMwNdt1v7FZl3C04LmnVpQWj2pdAzFuobNqfA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": false,
    "devTools": false,
    "devExceptions": false,
    "enableMatterSubtypePicklistSettingsEditing": false,
    "showMatterSubtypePicklistSettings": false,
    "showCustomPicklistSettings": false,
    "enableCustomPicklistSettingsEditing": false,
    "inputRelativeValidation": true,
    "showServiceAccountSettings": true,
    "notificationBellEnabled": true,
    "enableCloneMatter": true,
    "enableServeportPortalEdit": true,
    "enableServiceOfProcessBusinessHours": true,
    "enableBlackMamba": true,
    "enableFederalBenefitExemptionStatus": true,
    "enableEmailFileViewer": true,
    "enableNonPdfIntakeUpload": false,
    "enablePdfTemplates": false,
    "enableTaskGroups": false
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "378fb795-45ad-4a9d-9299-53df21a047d6"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=cc0c6453-a8e8-4532-8633-3712ba194ab8;IngestionEndpoint=https://eastus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=b6e4d866-02bc-4c30-a82d-dd9f4d0947d8"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    },
    "ckeditor": {
      "key": "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MjQ1OTUxOTksImp0aSI6ImY0MzIwNGQ2LTRkNTItNGM2MC1iNGMwLTg1YjdhYjg0MTQ2MSIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwiZmVhdHVyZXMiOlsiRFJVUCJdLCJ2YyI6IjFkZmQ4YzgxIn0.YBMx0L7dUwlyvAu7KrUCnQgQCRDoU8SAsc6uMj9kYMcPav6sy1KkJ9NJOIhyQjwUNpcxdQe8zWk3mvH6xSDk7g"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "lpms",
        "name": "matters",
        "url": "signalr/matters"
      },
      {
        "api": "lpms",
        "name": "correspondences",
        "url": "signalr/correspondences"
      },
      {
        "api": "lpms",
        "name": "notifications",
        "url": "signalr/notifications"
      },
      {
        "api": "lpms",
        "name": "intake-files",
        "url": "signalr/intake-files"
      }
    ]
  }
}
